module.exports = __webpack_public_path__ + "27366dccef2c5e7c67643b2d61839e0f.svg";